import React from "react";
import {
  NavLink,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Faculties from "pages/Onboarding/Faculties";
import Leaders from "pages/Onboarding/Leaders";
import Teachers from "pages/Onboarding/Teachers";
import ChatBot from "pages/Onboarding/ChatBot";
import LF from "pages/Onboarding/LandingForm/LF";
import Preview from "pages/Onboarding/Preview";
import LinkYourAccounts from "pages/Onboarding/Step4/LinkYourAccounts";
import Occasions from "pages/Onboarding/Step4/Occasions";
import NewRecognitions from "pages/Onboarding/Recognition/NewRecognitions";
import NewTestimonials from "pages/Onboarding/Testimonials/NewTestimonials";
import NewBranding from "pages/Onboarding/Brochures/NewBranding";
import NewCampusInfo from "pages/Onboarding/CampusInfo/NewCampusInfo";
import Notifications from "pages/Onboarding/Step4/Notifications";
import ParentInsights from "pages/Onboarding/Step5/ParentInsights";
import AIManagmentHub from "pages/Onboarding/Step6/AIManagmentHub";
import AutoConnectHub from "pages/Onboarding/Step2/AutoConnectHub";
import { Img } from "components";
import ContentEngagement from "pages/Onboarding/Step4/ContentEngagement";
import ProcessComplete from "pages/Onboarding/ProcessComplete";
import NewAutoFeeHub from "pages/Onboarding/Step3/AutoFeeHub/NewAutoFeeHub";
import Template from "pages/Onboarding/Template";
import Stopwatch from "components/Stopwatch";
import Lottie from "lottie-react";
import RedDotAnimation from "assets/images/RedDotAnimation.json";
import WhatsApp from "pages/Onboarding/Whatsapp";
import TemplateMedia from "pages/Onboarding/TemplateMedia";

const SFR = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [formKey, setFormKey] = React.useState(Date.now());

  let instituteData = null;
  try {
    instituteData = JSON.parse(sessionStorage?.getItem("_DATA_") || "{}");
  } catch (err) {}

  const YOUR_WEBSITE_FORMS = [
    {
      label: "School Info",
      route: "/onboarding/instituteInfo",
      value: sessionStorage.getItem("Institute"),
      id: "Institute",
    },
    {
      label: "Founders/Leader info",
      route: "/onboarding/instituteInfo/founders",
      value: sessionStorage.getItem("founders"),
      id: "founders",
    },
    {
      label: "Faculty/Teachers info",
      route: "/onboarding/instituteInfo/faculties",
      value: sessionStorage.getItem("faculties"),
      id: "faculties",
    },
    {
      label: "Recognitions",
      route: "/onboarding/instituteInfo/recognition",
      value: sessionStorage.getItem("recognitions"),
      id: "recognitions",
    },
    {
      label: "Template",
      route: "/onboarding/instituteInfo/template",
      value: sessionStorage.getItem("template"),
      id: "template",
    },
    {
      label: "Media",
      route: "/onboarding/instituteInfo/templateMedia",
      value: sessionStorage.getItem("templateMedia"),
      id: "templateMedia",
    },
    // {
    //   label: "Campus Info",
    //   route: "/onboarding/instituteInfo/campusinfo",
    //   value: sessionStorage.getItem("campus"),
    //   id: "campus",
    // },
    {
      label: "AI Avatar",
      route: "/onboarding/instituteInfo/chatbot",
      value: sessionStorage.getItem("Chatbot"),
      id: "aiAvatar",
    },
    {
      label: "Testimonials",
      route: "/onboarding/instituteInfo/testimonials",
      value: sessionStorage.getItem("testimonials"),
      id: "testimonials",
    },
    {
      label: "Branding Materials",
      route: "/onboarding/instituteInfo/branding",
      value: sessionStorage.getItem("materials"),
      id: "materials",
    },
  ];

  const SOCIAL_HUB_FORMS = [
    {
      label: "Link your accounts",
      route: "/onboarding/socialHubInfo",
      value: sessionStorage.getItem("socialHubInfo"),
    },
    {
      label: "Occasions",
      route: "/onboarding/socialHubInfo/occasions",
      value: sessionStorage.getItem("occasions"),
    },
    // { label: "Select notifications", route: "/onboarding/socialHubInfo/notification", value: sessionStorage.getItem("notification") },
    {
      label: "Content engagement",
      route: "/onboarding/socialHubInfo/content-engagement",
      value: sessionStorage.getItem("countentEngagement"),
    },
  ];

  const AUTO_FEE_HUB__FORMS = [
    {
      label: "Auto Fee Hub",
      route: "/onboarding/autoFeeHub",
      value: sessionStorage.getItem("autoFeeHub"),
      id: "autoFeeHub",
    },
  ];

  const AUTO_CONNECT_HUB__FORMS = [
    {
      label: "Auto Connect Hub",
      route: "/onboarding/autoConnectHub",
      value: sessionStorage.getItem("autoConnectHub"),
      id: "autoConnectHub",
    },
  ];

  const AI_MANAGMENT_HUB__FORMS = [
    {
      label: "AI Management Hub",
      route: "/onboarding/aiManagementHub",
      value: sessionStorage.getItem("aiManagementHub"),
      id: "aiManagementHub",
    },
  ];

  const PARENTAL_INSIGHTS = [
    {
      label: "Parental insights",
      route: "/onboarding/parentalInsights",
      value: sessionStorage.getItem("parentalInsights"),
      id: "parentalInsights",
    },
  ];

  const STEPS = [
    {
      label: "Your Website",
      options: YOUR_WEBSITE_FORMS,
      route: "/onboarding/instituteInfo",
      id: "instituteInfo",
      status: !!instituteData?.BRANCH_ID,
    },
    {
      label: "Auto Connect Setup",
      options: AUTO_CONNECT_HUB__FORMS,
      route: "/onboarding/autoConnectHub",
      id: "autoConnectHub",
      status: "",
    },
    {
      label: "Auto Fee Hub Integration",
      options: AUTO_FEE_HUB__FORMS,
      route: "/onboarding/autoFeeHub",
      id: "autoFeeHub",
      status: "",
    },
    {
      label: "Social Hub Integration",
      options: SOCIAL_HUB_FORMS,
      route: "/onboarding/socialHubInfo",
      id: "socialHubInfo",
      status: "",
    },
    {
      label: "Parental insights",
      options: PARENTAL_INSIGHTS,
      route: "/onboarding/parentalInsights",
      id: "parentalInsights",
      status: "",
    },
    {
      label: "AI Management Hub",
      options: AI_MANAGMENT_HUB__FORMS,
      route: "/onboarding/aiManagementHub",
      id: "aiManagementHub",
      status: "",
    },
  ];

  function getStepObject(url) {
    const baseRoute = url?.split("/")?.slice(0, 3)?.join("/"); // Extract the first three parts of the URL
    return (
      STEPS?.find((step) => step?.route === baseRoute)?.options || ([] as any)
    );
  }

  const renderNavLinkClasses = (route?) => {
    if (location?.pathname === route) {
      return {
        value:
          "text-[2.4vh] inline-block py-2 px-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500",
        clickable: true,
      };
    } else {
      return {
        value:
          "text-[2.4vh] inline-block py-2 px-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300",
        clickable: false,
      };
    }
  };

  const resetFormData = () => {
    sessionStorage.removeItem(
      getStepObject(location?.pathname)?.find(
        (item) => item?.route === location?.pathname
      )?.id
    );
    setFormKey((formKey) => Date.now());
  };

  const handleNavigate = (preview?: boolean, link?: string) => {
    if (preview) {
      // navigate("/onboarding/instituteInfo/preview");
      window.location.href = "/onboarding/instituteInfo/preview";
    } else if (link) {
      navigate(link);
    } else {
      navigate(
        getStepObject(location?.pathname)?.[
          getStepObject(location?.pathname)?.findIndex(
            (item) => item?.route === location?.pathname
          ) + 1
        ]?.route
      );
    }
  };

  function canNavigate(array, index, checkForTab = false) {
    if (checkForTab) {
      if (index === 0) return true; // If index is 0, return true

      // Get the previous index value from the array
      const previousItem = array?.[index - 1];

      // Check if previousItem exists and has a truthy value
      return previousItem?.value ? true : false;
    } else {
      if (index === 0) return true; // If index is 0, return true

      // Get the previous index value from the array
      const previousItem = array?.[index - 1];

      // Check if previousItem exists and has a truthy value
      return !!previousItem?.status ? true : false;
    }
  }

  return (
    <div
      key={formKey}
      className="mx-auto font-manrope text-gray-ob sm:px-4 lg:px-8"
    >
      <nav className="flex w-full justify-between items-center bg-[#F9EBFF] p-1 sm:p-4">
        <div className="flex w-full items-center gap-2 sm:gap-4">
          <NavLink to="/" style={{ width: "3.5vw" }}>
            <Img
              className="w-[10vw] sm:w-[6vw] lg:w-[3vw] h-auto object-contain mx-auto"
              src={"/images/Logo.svg"}
              alt="SooMuch Logo"
              loading={"lazy"}
            />
          </NavLink>
          <p className="font-semibold sm:text-lg md:text-xl text-[2.4vh]">
            Onboarding Setup
          </p>
        </div>
        <div className="flex gap-4 justify-end items-center w-[25%]">
          <Stopwatch />
          <button
            onClick={() => window.open("https://soomuch.ai/explore", "_blank")}
            type="button"
            className="flex items-center gap-2 p-2 bg-[white] text-[#EA4040] font-manropeSB w-fit rounded-xl"
          >
            <Lottie animationData={RedDotAnimation} className="w-5" />
            Live Demo
          </button>
        </div>
      </nav>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4 p-2">
        {![
          "/onboarding/onboarding-complete",
          "/onboarding/onboarding-whatsapp",
        ].includes(location?.pathname) && (
          <div className="col-span-12 sm:hidden md:hidden laptop:block">
            <div className="newStepperWrapperOB">
              {STEPS?.map((item, index) => (
                <NavLink
                  // to={item?.route} key={"alsdkjasbdasdmasd" + index} className={`newStepperItemOB ${location?.pathname?.includes(item?.id) ? "newActiveOB newCompletedOB" : ""}`}
                  to={item?.route}
                  key={"alsdkjasbdasdmasd" + index}
                  className={`newStepperItemOB ${
                    location?.pathname?.includes(item?.id) ? `newActiveOB` : ""
                  } ${!!item?.status && "newCompletedOB"}`}
                  // style={{ pointerEvents: canNavigate(STEPS, index) ? "auto" : "none", color: !canNavigate(STEPS, index) && "gray" }}
                >
                  <div
                    className={`newStepCounterOB ${
                      location?.pathname?.includes(item?.id)
                        ? "newActiveOB"
                        : ""
                    }`}
                  >
                    <div className="newCounterBubble" />
                  </div>
                  <div className="font-semibold text-[2vh] text-center w-[70%]">
                    Step {index + 1}
                  </div>
                  <div className="text-[2vh] text-center w-[70%] mt-1">
                    {item?.label}
                  </div>
                </NavLink>
              ))}
            </div>
          </div>
        )}

        {getStepObject(location?.pathname)?.length > 1 && (
          <div className="col-span-12 border-y border-solid mx-10 md:hidden">
            <ul className="font-thin text-center text-gray-500 flex">
              {getStepObject(location?.pathname)?.map((item, index) => (
                <li key={"asdnaskjdasjdad" + index}>
                  <NavLink
                    end={item?.route === "/onboarding/*"}
                    to={item?.route}
                    key={"akjdilqwejhkdhasdasd" + index}
                    type="button"
                    className={renderNavLinkClasses(item?.route)?.value}
                    aria-current={"page"}
                    // style={{ pointerEvents: canNavigate(getStepObject(location?.pathname), index, true) ? "auto" : "none", opacity: canNavigate(getStepObject(location?.pathname), index, true) ? 1 : 0.5 }}
                  >
                    {item?.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div
          className={`col-span-12 sm:col-span-12 md:col-span-12 rounded-3xl ${
            getStepObject(location?.pathname)?.length <= 1 && "mt-[1vh]"
          }`}
        >
          <Routes>
            <Route
              path="/instituteInfo"
              element={
                <LF
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/founders"
              element={
                <Leaders
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/faculties"
              element={
                <Faculties
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/recognition"
              element={
                <NewRecognitions
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/testimonials"
              element={
                <NewTestimonials
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/branding"
              element={
                <NewBranding
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/teachers"
              element={
                <Teachers
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/chatbot"
              element={
                <ChatBot
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/campusinfo"
              element={
                <NewCampusInfo
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                  disableForm={undefined}
                />
              }
            />
            <Route
              path="/instituteInfo/preview"
              element={
                <Preview
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/template"
              element={
                <Template
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/templateMedia"
              element={
                <TemplateMedia
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                  disableForm={undefined}
                />
              }
            />
            <Route
              path="/socialHubInfo"
              element={
                <LinkYourAccounts
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/socialHubInfo/occasions"
              element={
                <Occasions
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/socialHubInfo/notification"
              element={
                <Notifications
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/socialHubInfo/content-engagement"
              element={
                <ContentEngagement
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/autoFeeHub"
              element={
                <NewAutoFeeHub
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/autoConnectHub"
              element={
                <AutoConnectHub
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/aiManagementHub"
              element={
                <AIManagmentHub
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/parentalInsights"
              element={
                <ParentInsights
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route path="/onboarding-complete" element={<ProcessComplete />} />
            <Route path="/onboarding-whatsapp" element={<WhatsApp />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default SFR;
